export * from './tipo-variacao.pipe';
